import CONSTANT from "@api/constant";
export default [{
  path: '/market',
  name: 'market',
  meta: {
    platformType: CONSTANT.SHOP
  },
  component: function component() {
    return import('@/layouts/market-layout');
  },
  redirect: {
    name: 'm-userMemberCenter'
  },
  children: [{
    path: 'userMemberCenter',
    name: 'm-userMemberCenter',
    component: function component() {
      return import('@/pagesMarket/user/memberCenter/memberCenter/index.vue');
    }
  }]
}];